export default __webpack_public_path__ + "static/AnastasiiaKuzniasova-fa373675a2bf34ce0aae3f6de159e5e2.png";